var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":_vm.loading}},[_c('v-img',{attrs:{"height":"100%","width":"100%","min-height":"10rem","src":_vm.post.category === '크레파스 워십'
        ? ("https://drive.google.com/uc?export=view&id=" + (_vm.post.imageUrl))
        : ("https://img.youtube.com/vi/" + (_vm.post.youtubeUrl) + "/0.jpg")},on:{"click":function($event){$event.stopPropagation();return _vm.clickPost()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }